
enum MarketInsightOccupancyDrillDownType {
	HOTEL_RATING = 'HOTEL_RATING',
	ROOM_TYPE = 'ROOM_TYPE'
}

export default MarketInsightOccupancyDrillDownType;
